import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductType } from '@core/models/api/dsm-types';
import {
  UwIssuesProductView,
  UwIssuesViewModel,
} from '../../uw-reports-card/uw-reports-view-model';
import { ModalService } from '@shared/services/modal.service';
import { ProductsService } from '@core/services/products.service';
import { UwIssuesByProduct } from '@entities/uw-issues/uw-issues.selector';
import { ProductUtils } from '@shared/utils/product.util';
import { ProductHelper } from '@core/helper/product.helper';
import { UserModel } from '@entities/user/user.model';
import { Nullable } from '@shared/utils/type.utils';
import { FeatureFlagsModel } from '@entities/feature-flag/feature-flag.model';

@Component({
  selector: 'nwx-next-step-uw-issues',
  templateUrl: './next-step-uw-issues.component.html',
  styleUrls: ['./next-step-uw-issues.component.scss'],
  standalone: false,
})
export class NextStepUwIssuesComponent implements OnChanges {
  @Input() uwIssues: UwIssuesByProduct = {};
  @Input() disabledProducts: ProductType[] = [];
  @Input() user!: UserModel | null;
  @Input() featureFlags: Nullable<FeatureFlagsModel>;

  model: UwIssuesViewModel = { products: [] };

  constructor(
    private modalService: ModalService,
    private productsService: ProductsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.uwIssues || changes.disabledProducts) {
      this.model = { products: [] };
      for (const productType of Object.keys(this.uwIssues) as ProductType[]) {
        if (
          !this.featureFlags?.dwellingFireStandalone &&
          ProductHelper.hasBlockedByPropertyIssue(
            productType,
            this.uwIssues[productType]
          )
        ) {
          continue;
        }

        this.model.products.push({
          productType,
          productName: ProductUtils.getShortNameForProduct(productType),
          disableApproval: this.disabledProducts.includes(productType),
          issues: this.uwIssues[productType]!.map((issue) => issue.description),
          issueDetails: this.uwIssues[productType]!.map(
            (issue) => issue.category
          ),
        });
      }
    }
  }

  onRequestUwApproval(
    productType: ProductType,
    user: Nullable<UserModel>
  ): void {
    this.modalService.uwReferralModal(productType, user);
  }

  onRemoveProduct(productType: ProductType): void {
    this.productsService.selectProduct(productType, false);
  }

  hasDisabled(product: UwIssuesProductView): boolean {
    return (
      product.issueDetails?.some((issue: string) =>
        issue.includes('Critical Block')
      ) ?? false
    );
  }
}
